export var Source;
(function (Source) {
    Source["api"] = "api";
    Source["user"] = "user";
    Source["history"] = "history";
    Source["input"] = "input";
    Source["paste"] = "paste";
})(Source || (Source = {}));
